import React from 'react';

const PAYMENT_METHODS = ['especes', 'carte', 'virement', 'cheque'];

export default function InvoicePaymentModal({ payForm, setPayForm, onSubmit, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="payment-modal">
      <div className="bg-white rounded-xl w-full max-w-sm p-5">
        <h3 className="font-semibold mb-4">Enregistrer un paiement</h3>
        <div className="space-y-3">
          <input type="number" step="0.01" placeholder="Montant" value={payForm.amount} onChange={e => setPayForm({ ...payForm, amount: parseFloat(e.target.value) || 0 })} className="w-full border rounded-lg px-3 py-2 text-sm" data-testid="payment-amount" />
          <select value={payForm.method} onChange={e => setPayForm({ ...payForm, method: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm" data-testid="payment-method">
            {PAYMENT_METHODS.map(m => <option key={m} value={m} className="capitalize">{m}</option>)}
          </select>
          <input placeholder="Notes" value={payForm.notes} onChange={e => setPayForm({ ...payForm, notes: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm" data-testid="payment-notes" />
          <div className="flex justify-end gap-3">
            <button onClick={onClose} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Annuler</button>
            <button onClick={onSubmit} className="px-4 py-2 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700" data-testid="payment-submit">Encaisser</button>
          </div>
        </div>
      </div>
    </div>
  );
}
